import { net } from 'zf-web-infra';
import type * as Types from '../types';

export class FeishuLoginService {

  private static readonly OAuthTransactionKey = 'feishu-login-oauth';

  private static readonly OAuthTransactionLifetimeMs = 10 * 60 * 1000;

  async fetchConfig(params: { tenant: string; app: string }): Promise<Types.FeishuLoginSettingResponse> {
    return await net.get<Types.FeishuLoginSettingResponse>('/api/account/feishuQRLoginSetting', params);
  }

  async login(params: Types.FeishuLoginParams): Promise<Types.LoginResponse> {
    return await net.post<Types.LoginResponse>('/api/account/feishuQRLogin', params);
  }

  createOAuthUrl(params: Types.FeishuOAuthParams): string {
    const oauthUrl = new URL('https://accounts.feishu.cn/open-apis/authen/v1/authorize');
    oauthUrl.searchParams.set('app_id', params.appId);
    oauthUrl.searchParams.set('redirect_uri', params.redirectUri);
    oauthUrl.searchParams.set('scope', 'contact:user.employee_id:readonly');
    oauthUrl.searchParams.set('state', params.state);
    return oauthUrl.toString();
  }

  createOAuthTransaction(
    tenant: string,
    redirectUri: string,
    redirect?: string
  ): Types.FeishuOAuthTransaction {
    const bytes = crypto.getRandomValues(new Uint8Array(16));
    const state = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('');
    const transaction = { state, tenant, redirectUri, redirect, createdAt: Date.now() };
    sessionStorage.setItem(FeishuLoginService.OAuthTransactionKey, JSON.stringify(transaction));
    return transaction;
  }

  consumeOAuthTransaction(state?: string): Types.FeishuOAuthTransaction | undefined {
    const serialized = sessionStorage.getItem(FeishuLoginService.OAuthTransactionKey);
    sessionStorage.removeItem(FeishuLoginService.OAuthTransactionKey);
    if (serialized == null || state == null || state === '') {
      return;
    }

    try {
      const transaction = JSON.parse(serialized) as Types.FeishuOAuthTransaction;
      if (
        typeof transaction.state !== 'string'
        || typeof transaction.tenant !== 'string'
        || typeof transaction.redirectUri !== 'string'
        || typeof transaction.createdAt !== 'number'
      ) {
        return;
      }
      const expired = Date.now() - transaction.createdAt > FeishuLoginService.OAuthTransactionLifetimeMs;
      if (expired || transaction.state !== state || transaction.tenant === '') {
        return;
      }
      return transaction;
    } catch {
      return;
    }
  }

}
